import * as React from 'react';
import {translate, Interpolate, InjectedTranslateProps} from 'react-i18next';
import {reportClick} from '../../utils/bi';
import LinkMore from '../LinkMore';
import * as s from './Marketing.scss';
import LazyLoad from 'react-lazyload';
import NoScript from '../NoScript';

export interface MarketingProps extends InjectedTranslateProps {
  staticsBaseUrl: string;
}

const getAssetUrl = (filePath: string, staticsBaseUrl: string) => {
  return `${staticsBaseUrl}assets/images/${filePath}`;
};

const Marketing: React.SFC<MarketingProps> = ({t, staticsBaseUrl}) => {
  const breakpoints = [1024, 1280, 1360, 1440, 1600, 1920];
  return (
    <div className={`page-fold ${s.marketing}`} data-foldname="marketing" data-foldnum="5">
      <div className={s.block}>
        <Interpolate parent="h2" className={s.title} i18nKey="marketing.title1" lineBreak={<br/>}/>
        <p className={s.paragraph}>{t('marketing.text1')}</p>
        <div className={s.footer}>
          <LinkMore
            data-hook="marketing-get-started"
            className={s.linkMore}
            data-foldname="marketing"
            onClick={reportClick}
          >
            {t('button.getStarted')}
          </LinkMore>
        </div>
      </div>
      <div className={s.block}>
        <Interpolate parent="h2" className={s.title} i18nKey="marketing.title2" lineBreak={<br/>}/>
        <Interpolate parent="p" className={s.paragraph} i18nKey="marketing.text2" lineBreak={<br/>}/>
        <div className={s.footer}>
          <LinkMore
            data-hook="marketing-get-started"
            className={s.linkMore}
            data-foldname="marketing"
            onClick={reportClick}
          >
            {t('button.getStarted')}
          </LinkMore>
        </div>
      </div>
      <div className={s.image}>
        <picture>
          {breakpoints.sort().reverse().map(value => (
            <source key={value} media={`(min-width: ${value}px)`} srcSet={getAssetUrl(`marketing/man-thinking/${value}.jpg`, staticsBaseUrl)}/>
          ))}
          <source srcSet={getAssetUrl('marketing/man-thinking/mobile.jpg', staticsBaseUrl)}/>

          <NoScript>
            <img src={getAssetUrl('marketing/man-thinking.jpg', staticsBaseUrl)} alt={t('seo.marketing.alt')}/>
          </NoScript>
          <LazyLoad height={828} once>
            <img src={getAssetUrl('marketing/man-thinking.jpg', staticsBaseUrl)} alt={t('seo.marketing.alt')}/>
          </LazyLoad>
        </picture>
      </div>
    </div>
  );
};

export default translate()(Marketing);
